import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    paddingBottom: 0,
  },
  title: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  rankIcon: {
    fontSize: 20,
    marginLeft: 4,
  },
});
